<template>
	<modal ref="modal">
		<template #title>AFFILIATE NAME</template>
		<template #body>
			<div class="row justify-content-center">
				<div class="col-md-4">
					<div class="text-center block">
						Affiliate Name
						<div class="h3 mb-5 text-danger">{{affData.affname}}</div>
					</div>
				</div>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control">{{affData.member_name}}</div>
				<label class="form-label" for="source">Member</label>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control">{{affData.username}}</div>
				<label class="form-label" for="username">Username</label>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control">{{affData.mobile}}</div>
				<label class="form-label" for="mobile">Mobile#</label>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control" :class="{'text-warning':affData.affname_status=='Pending','text-danger':affData.affname_status=='Declined','text-success':affData.affname_status=='Approved'}">{{affData.affname_status}}</div>
				<label class="form-label" for="mobile">Status</label>
			</div>

			<div class="form-group mb-4">
				<div class="border-bottom border-info pb-1">Log History</div>
				<table class="table">
					<thead>
						<tr>
							<th>Affiliate Name</th>
							<th>Ip Address</th>
							<th>Created</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(log,l_index) in affData.logs_affname">
							<td>{{log.affname}}</td>
							<td>{{log.ip_address}}</td>
							<td>{{log.created_at}}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="form-group mb-4">
				<label class="form-label" for="mobile">Remarks (For Declined Purpose)</label>
				<textarea v-model="form.declined_remarks" rows="5" class="form-control"></textarea>
			</div>

		</template>
		<template #footer>
			<button 
				@click="affnameApproval('Approved')"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || affData.affname_status=='Approved'"
			>
				<span v-if="!form.processing"><i class="fa fa-check me-2"></i>Approved</span>
				<span v-else-if="form.processing && form.affname_status=='Approved'">
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button 
				@click="affnameApproval('Declined')"
				type="submit"
				class="btn btn-alt-danger"
				:disabled="form.processing || affData.affname_status=='Declined'"
			>
				<span v-if="!form.processing"><i class="fa fa-times me-2"></i>Declined</span>
				<span v-else-if="form.processing && form.affname_status=='Declined'">
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { createToaster } from '@meforma/vue-toaster'

export default {
	setup(props) {

		const toast = createToaster();

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const affData = reactive({});

		const form = useForm({
			counter 			: 0,
			affname 			: '',
			declined_remarks 	: '',
			affname_status		: '',
			prev_affname_status	: ''
		})

		const affnameApproval = (_status) => {

			if(_status=="Declined")
			{
				if(form.declined_remarks=="" || form.declined_remarks==null)
				{
					toast.show("Remarks is required", { type: "error"});
					return false;
				}
			}

			form.affname_status = _status;
			form.put('affiliate-name-approval/'+form.counter, {
				preserveState: true,
				preserveScroll: true,
				only:['affNameApproval,api_response'],
				onSuccess: () => {
					affData.affname_status = _status;
					form.reset();
					toggleModal();
				},
			})
		}

		const setAffNameContent = (data)=>{
								
								form.reset();

								Object.assign(affData,data);

								form.counter 				= data.counter;
								form.affname 				= data.affname;
								form.prev_affname_status 	= data.affname_status;
								
							}


		return {
			form,
			modal,
			toggleModal,
			affData,
			setAffNameContent,
			affnameApproval,
		}
	},
}
</script>
